
import { Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CoordinatesModel } from 'src/app/share/models';
import { Helper } from 'src/app/share/helper';
import { LocationsConstants } from 'src/app/share/locationsConstants';
import { WeatherServiceApiService } from 'src/app/service/weather-service-api.service';
import { WindBarbComponent } from '../wind-barb/wind-barb.component';
import { IAllDayThermicIndexModel, ICoordinatesModel, IPromptContext, IThermicIndexResult } from 'src/app/share/interfaces';
import { LocationsEnum } from 'src/app/share/enums';
import { AIHelper } from 'src/app/share/aiHelper';
import { Clipboard } from "@angular/cdk/clipboard"
import { BigDataService } from 'src/app/service/big-data.service';
import { GpzxService } from 'src/app/service/gpzx.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';



@Component({
  selector: 'app-thermic-index-with-api',
  templateUrl: './thermic-index-with-api.component.html',
  styleUrls: ['./thermic-index-with-api.component.css'],
  standalone: false
})
export class ThermicIndexWithApiComponent implements OnInit {





  showCapeInfo = false;
  private entry: ViewContainerRef;
  thermicForm: UntypedFormGroup;
  result: IThermicIndexResult;
  selectedLocation: string;
  today: Date;
  private minTen = new Date(Date.now() - 10 * 24 * 60 * 60 * 1000);
  private maxTen = new Date(Date.now() + 10 * 24 * 60 * 60 * 1000);
  private selectedDate: string;
  location: CoordinatesModel;
  selectedModel: string;
  minDate: any;
  maxDate: any;
  tDay = new Date();
  setFlySimulatorLink: boolean = false;
  @ViewChild('windBarbContainer', { read: ViewContainerRef, static: false }) set content(content: ViewContainerRef) {
    if (content) { // initially setter gets called with undefined
      this.entry = content;
      this.createWindBarb(this.result?.windSpeed850hPa, this.result?.windDirection850hPa, 999);
    }
  }
  private _topScroller!: ElementRef;
  private _tableResponsive!: ElementRef;

  // Flag to ensure listeners are attached only once
  private scrollListenersAttached: boolean = false;

  tableContentWidth: number = 0; // Property to hold the calculated scroll width

  // Use setter methods for ViewChild to react when elements are rendered
  @ViewChild('topScroller')
  set topScroller(el: ElementRef) {
    this._topScroller = el;
    this.synchronizeScrollbars(); // Call synchronization logic when this element is available
  }
  get topScroller(): ElementRef {
    return this._topScroller;
  }

  @ViewChild('tableResponsive')
  set tableResponsive(el: ElementRef) {
    this._tableResponsive = el;
    this.synchronizeScrollbars(); // Call synchronization logic when this element is available
  }
  get tableResponsive(): ElementRef {
    return this._tableResponsive;
  }
  @ViewChild('radarModalContent') radarModalContent: any;


  fullRadarImageUrlInModal: string = '';

  constructor(private weatherApi: WeatherServiceApiService, private gpxService: GpzxService, private clipboard: Clipboard,
    private bigDataService: BigDataService, private modalService: NgbModal, private sanitizer: DomSanitizer) {
  }


  ngOnInit(): void {
    this.minDate = { day: this.minTen.getDate(), month: this.minTen.getMonth() + 1, year: this.minTen.getFullYear() };
    this.maxDate = { day: this.maxTen.getDate(), month: this.maxTen.getMonth() + 1, year: this.maxTen.getFullYear() };
    this.thermicForm = new UntypedFormGroup({
      location: new UntypedFormControl('Ayas', Validators.required),
      weatherModel: new UntypedFormControl('ecmwf_ifs025', Validators.required),
      latitude: new UntypedFormControl(null, [Validators.min(-90), Validators.max(90)]),
      longitude: new UntypedFormControl(null, [Validators.min(-90), Validators.max(90)]),
      elavation: new UntypedFormControl(null),
      forecastDuration: new UntypedFormControl('12'),
      sDate: new UntypedFormControl({
        "year": this.tDay.getFullYear(),
        "month": this.tDay.getMonth() + 1,
        "day": this.tDay.getDate()
      }, Validators.required)
    });
    this.setLocation(this.thermicForm.controls['location'].value);

  }
  private synchronizeScrollbars(): void {
    // Ensure both elements are available and listeners haven't been attached yet
    if (this._topScroller && this._tableResponsive && !this.scrollListenersAttached) {
      // Use setTimeout(0) to ensure the DOM has fully rendered after the component view is initialized,
      // especially important when content is dynamically added after a button click.
      setTimeout(() => {
        // Calculate the width of the scrollable content to set the inner div's width
        this.tableContentWidth = this._tableResponsive.nativeElement.scrollWidth;

        // Synchronize top scroller to bottom scroller
        this._topScroller.nativeElement.onscroll = () => {
          this._tableResponsive.nativeElement.scrollLeft = this._topScroller.nativeElement.scrollLeft;
        };

        // Synchronize bottom scroller to top scroller
        this._tableResponsive.nativeElement.onscroll = () => {
          this._topScroller.nativeElement.scrollLeft = this._tableResponsive.nativeElement.scrollLeft;
        };

        this.scrollListenersAttached = true; // Set flag to prevent re-attaching listeners
      }, 0); // Defer execution to the next microtask queue
    }
  }

  async onSubmit() {
    this.setFlySimulatorLink = false;
    if (this.thermicForm.invalid) {
      return;
    }

    if (this.location === null) {
      let longitude = this.thermicForm.controls['longitude'].value;
      let latitude = this.thermicForm.controls['latitude'].value;
      let elavation = this.thermicForm.controls['elavation'].value;
      this.location = {
        latitude: latitude,
        longitude: longitude,
        elevation: elavation,
      }
    }
    this.selectedModel = this.thermicForm.controls['weatherModel'].value;

    this.selectedDate = this.thermicForm.controls['sDate'].value.year + '-' + Helper.pad(this.thermicForm.controls['sDate'].value.month)
      + '-' + Helper.pad(this.thermicForm.controls['sDate'].value.day);
    this.today = new Date(this.selectedDate + ' ' + this.tDay.getHours() + ':' + this.tDay.getMinutes());
    let forecastDuration = this.thermicForm.controls['forecastDuration'].value;
    await this.weatherApi.getWeatherForLocation(this.location,
      this.today, this.selectedDate, this.selectedModel, forecastDuration).subscribe({
        next: (result) => {
          this.result = Helper.getThermicIndex(result, false);
          this.bigDataService.getLocationData(this.location).subscribe({
            next: (placeName) => {
              this.selectedLocation = placeName;
              this.setFlySimulatorLink = true;
            },
            error: (error) => {
              console.log(error);
            }
          });
          setTimeout(() => {
            if (this._tableResponsive) { // Ensure the element is available
              this.tableContentWidth = this._tableResponsive.nativeElement.scrollWidth;
            }
          }, 0);
        },
        error: (error) => {
          console.log(error);
        }
      });
  }

  createWindBarb(windSpeed: number, windDirection: number, divId: number) {
    this.entry.clear();
    const componentRef = this.entry.createComponent(WindBarbComponent);
    componentRef.instance.divId = divId;
    componentRef.instance.windSpeed = windSpeed;
    componentRef.instance.windDirection = windDirection;
  }
  setLocation(value: string): void {
    this.result = null;
    this.setFlySimulatorLink = false;
    this.selectedLocation = value !== '0' ? value : 'Özel Konum'
    const selectedValue = value;
    const latitudeCtrl = this.thermicForm.get('latitude');
    const longitudeCtrl = this.thermicForm.get('longitude');
    const elevationCtrl = this.thermicForm.get('elavation');
    if (selectedValue === '0') {
      latitudeCtrl?.enable();
      longitudeCtrl?.enable();
      elevationCtrl?.enable();
      latitudeCtrl?.setValidators([Validators.required]);
      longitudeCtrl?.setValidators([Validators.required]);
      elevationCtrl.setValidators([Validators.required]);
      latitudeCtrl?.setValue('');
      longitudeCtrl?.setValue('');
      elevationCtrl?.setValue('');
      this.location = null;

    } else {
      latitudeCtrl?.disable();
      longitudeCtrl?.disable();
      elevationCtrl?.disable();
      const locationEnum = LocationsEnum[selectedValue as keyof typeof LocationsEnum];
      this.location = LocationsConstants.getLocationCoordinates(locationEnum);
      latitudeCtrl?.setValidators([Validators.min(-90), Validators.max(90)]);
      longitudeCtrl?.setValidators([Validators.min(-90), Validators.max(90)]);
      elevationCtrl?.setValidators(null);

      latitudeCtrl?.setValue(this.location.latitude);
      longitudeCtrl?.setValue(this.location.longitude);
      elevationCtrl?.setValue(this.location.elevation);
    }

    latitudeCtrl?.updateValueAndValidity();
    longitudeCtrl?.updateValueAndValidity();
  }


  onMouseEnter(hourlyIndex: IAllDayThermicIndexModel) {
    this.result.altitude700Index = hourlyIndex.altitudeHourly700Index;
    this.result.altitude850Index = hourlyIndex.altitudeHourly850Index;
    this.result.indexComment = hourlyIndex.indexComment;

    let hourlyWind = this.result.hourlyWindModelList.find(x => x.hour === hourlyIndex.hour);
    this.result.windDirection850hPa = hourlyWind.windDirection_850hPa;
    this.result.windSpeed850hPa = hourlyWind.windSpeed_850hPa;
    this.result.hourlyGust = hourlyWind.windGusts10m;

    let hourlyCloud = this.result.hourlyCloudCoverModelList.find(x => x.hour === hourlyIndex.hour);
    this.result.cloudCover = hourlyCloud.cloudCover;

    // this.createWindBarb(hourlyWind.windSpeed_850hPa, hourlyWind.windDirection_850hPa, Math.random());
    //this.createPrompt(hourlyIndex);
  }

  private createPrompt(hourlyIndex: IAllDayThermicIndexModel) {
    let hourlyWind = this.result.hourlyWindModelList.find(x => x.hour === hourlyIndex.hour);
    let hourlyCloud = this.result.hourlyCloudCoverModelList.find(x => x.hour === hourlyIndex.hour);
    let hourlyRelativeHumidityModel = this.result.hourlyRelativeHumidityModelList.find(x => x.hour === hourlyIndex.hour);
    let hourlyTempModel = this.result.hourlyTempModelList.find(x => x.hour === hourlyIndex.hour);
    let prompt: IPromptContext = {
      longitude: this.location.longitude,
      latitude: this.location.latitude,
      date: this.selectedDate,
      elevation: this.location.elevation,
      timeHours: hourlyIndex.hour,
      tI850hPa: hourlyIndex.altitudeHourly700Index,
      tI700hPa: hourlyIndex.altitudeHourly850Index,
      winDirection850hPa: hourlyWind.windDirection_850hPa,
      winSpeed850hPa: hourlyWind.windSpeed_850hPa,
      winDirection700hPa: hourlyWind.windDirection_900hPa,
      winSpeed700hPa: hourlyWind.windSpeed_900hPa,
      temp700hPa: hourlyTempModel.temperature_700hPa,
      temp850hPa: hourlyTempModel.temperature_850hPa,
      cloudCover: hourlyCloud.cloudCover,
      relativeHumidity850hPa: hourlyRelativeHumidityModel.relativeHumidity850hPa,
      relativeHumidity700hPa: hourlyRelativeHumidityModel.relativeHumidity_700hPa,
      hourCape: hourlyCloud.hourlyCape,
      hourConvectiveCloudBase: hourlyCloud.hourlyConvectiveCloudBase == -500 ? 0 : hourlyCloud.hourlyConvectiveCloudBase,
    }
    var promptText = AIHelper.getPromptForThermicIndex(prompt);
    this.clipboard.copy(promptText);
  }

  getCurrentLocation() {
    this.gpxService.getUserLocation().subscribe({
      next: (location: ICoordinatesModel) => {
        this.thermicForm.controls['location'].setValue('0');
        this.setLocation('0');
        this.location = location;
        this.thermicForm.controls['latitude'].setValue(location.latitude);
        this.thermicForm.controls['longitude'].setValue(location.longitude);
        this.thermicForm.controls['elavation'].setValue(Math.round(location.elevation));

      },
      error: (error) => {
        console.error('Error getting user location:', error);
      }
    });
  }
  getPrecipitationTypeLabel(precipitationType: number, precipitationAmount: number): string {
    if (precipitationType === 0) {
      return 'Yok';
    } else if (precipitationType === 0 && precipitationAmount === 0.1) {
      return 'Yok';
    }
    if (precipitationAmount === 0) {
      return 'Yok';
    } else {
      return precipitationAmount + ' mm / ' + Helper.getPrecipitationTypeLabel(precipitationType, precipitationAmount);

    }


  }

  isSelectedDateToday(): boolean {
    const dateValue = this.thermicForm?.controls['sDate']?.value;
    if (!dateValue) {
      return false;
    }
    const today = new Date();
    return dateValue.day === today.getDate() &&
      dateValue.month === today.getMonth() + 1 &&
      dateValue.year === today.getFullYear();
  }

  openRadarModal(imageUrl: string): void {
    if (this.thermicForm.controls['location'].value !== '0' && this.isSelectedDateToday()) {
      this.fullRadarImageUrlInModal = imageUrl;
      this.modalService.open(this.radarModalContent, { size: 'lg', centered: true });
    }
  }

  openFlySimulator(): void {
    const now = new Date();

    const startDay = Math.floor(
      (Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) - Date.UTC(now.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24)
    );
    const startTime = 12 * 60;

    // Get wind at 12:00
    const middayWind = this.result.hourlyWindModelList.find(item => item.hour === "12:00");
    const windSpeed = middayWind?.windSpeed_850hPa ?? 15;
    const windDirection = middayWind?.windDirection_850hPa ?? 0;

    // Convert compass direction to degrees
    const compassToDegrees: Record<string, number> = {
      N: 0,
      NNE: 22.5,
      NE: 45,
      ENE: 67.5,
      E: 90,
      ESE: 112.5,
      SE: 135,
      SSE: 157.5,
      S: 180,
      SSW: 202.5,
      SW: 225,
      WSW: 247.5,
      W: 270,
      WNW: 292.5,
      NW: 315,
      NNW: 337.5
    };

    let takeoffDirection = 0;
    if (this.location.takeoffWindDirection && this.location.takeoffWindDirection.length > 0) {
      const randomIndex = Math.floor(Math.random() * this.location.takeoffWindDirection.length);
      const randomCompass = this.location.takeoffWindDirection[randomIndex];
      takeoffDirection = compassToDegrees[randomCompass] ?? 0;
    }

    const url = `https://paraglidinglogbook.com/simulator/sim_embed.php?location=${this.selectedLocation}` +
      `&type=full&takeoffdirection=${takeoffDirection}&windspeed=${windSpeed}&winddirection=${windDirection}` +
      `&startlat=${this.location.latitude}&startlon=${this.location.longitude}` +
      `&startday=${startDay}&starttime=${startTime}`;

    window.open(url, "_blank");
  }
}
